import { CabecaHumana3D, CorpoHumano3D } from './CorpoHumano3D'
import { Cruz3D } from './Cruz3D'
import { PecaDetalhe3D as Peca } from './PecaDetalhe3D'

/** Roupa e equipamentos de salvamento inspirados nas figuras do CSV Lab. */
export function FiguraProfissional3D({ tipo }: { tipo: 'bombeiroIncendio' | 'medico' }) {
  const medico = tipo === 'medico'
  return (
    <group name={tipo}>
      <CorpoHumano3D cor="#a16207" corLuvas={medico ? '#65bddd' : '#ea580c'} />
      <CabecaHumana3D />
      <Peca posicao={[0, 0.89, 0]} tamanho={[0.47, 0.18, 0.32]} cor="#a16207" raio={0.025} />
      {[0.89, 1.28].map((y) => (
        <group key={y}>
          <Peca posicao={[0, y, 0]} tamanho={[0.48, 0.075, 0.33]} cor="#fef08a" raio={0.01} />
          <Peca posicao={[0, y, 0]} tamanho={[0.485, 0.028, 0.335]} cor="#f8fafc" raio={0.006} />
        </group>
      ))}
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <mesh position={[lado * 0.125, 0.3, 0]}>
            <cylinderGeometry args={[0.08, 0.08, 0.065, 12]} />
            <meshStandardMaterial color="#fef08a" />
          </mesh>
          <Peca posicao={[lado * 0.295, 0.96, 0.06]} tamanho={[0.14, 0.045, 0.14]} cor="#fef08a" raio={0.02} />
          <Peca posicao={[lado * 0.12, 1.1, 0.157]} tamanho={[0.12, 0.13, 0.03]} cor="#875208" raio={0.015} />
        </group>
      ))}
      <mesh position={[0, 1.74, 0]} castShadow>
        <sphereGeometry args={[0.155, 18, 12, 0, Math.PI * 2, 0, Math.PI / 2]} />
        <meshStandardMaterial color={medico ? '#f8fafc' : '#dc2626'} roughness={0.35} />
      </mesh>
      <mesh position={[0, 1.73, 0]}>
        <cylinderGeometry args={[0.185, 0.19, 0.03, 18]} />
        <meshStandardMaterial color={medico ? '#e2e8f0' : '#b91c1c'} />
      </mesh>
      <Peca posicao={[0, 1.89, 0]} tamanho={[0.035, 0.045, 0.22]} cor="#fef08a" raio={0.01} />
      <Peca posicao={[0, 1.69, 0.142]} tamanho={[0.2, 0.09, 0.03]} cor="#b5a66d" metal={0.5} rugosidade={0.18} raio={0.015} />
      {medico && (
        <>
          <group position={[0, 1.78, 0.153]} scale={0.09}><Cruz3D /></group>
          <Peca posicao={[0.42, 0.61, 0.08]} tamanho={[0.26, 0.27, 0.19]} cor="#b91c1c" raio={0.025} />
          <Peca posicao={[0.42, 0.77, 0.08]} tamanho={[0.13, 0.06, 0.035]} cor="#26323b" raio={0.015} />
          <group position={[0.42, 0.61, 0.18]} scale={0.14}><Cruz3D cor="#ffffff" /></group>
          <mesh position={[-0.42, 0.54, 0.07]} castShadow>
            <capsuleGeometry args={[0.07, 0.3, 4, 12]} />
            <meshStandardMaterial color="#2e9363" metalness={0.35} roughness={0.4} />
          </mesh>
          <Peca posicao={[-0.42, 0.79, 0.07]} tamanho={[0.08, 0.07, 0.06]} cor="#b9c7cf" metal={0.7} raio={0.01} />
          <mesh position={[-0.42, 0.83, 0.11]} rotation={[Math.PI / 2, 0, 0]}>
            <cylinderGeometry args={[0.027, 0.027, 0.018, 12]} />
            <meshStandardMaterial color="#f8fafc" />
          </mesh>
        </>
      )}
    </group>
  )
}
